import React from 'react'
import { Link } from 'react-router-dom'
import { imageUrl } from '../lib/images'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-[#0c304d] text-white border-t border-neutral-800">
      {/* Top Banner: Invitation & Mission */}
      <div className="bg-[#081f33] py-12 px-4 sm:px-6 lg:px-8 border-b border-white/10">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-center md:text-left max-w-2xl">
            <span className="text-[#f39223] font-semibold text-xs tracking-wider uppercase">
              Sammen gør vi en forskel
            </span>
            <h2 className="text-2xl sm:text-3xl font-bold text-white mt-1">
              Er du ung, forælder eller samarbejdspartner?
            </h2>
            <p className="text-neutral-300 mt-2 text-sm sm:text-base leading-relaxed">
              Vi er altid klar til en uforpligtende samtale om, hvordan vi bedst kan støtte op om en tryg og positiv udvikling.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 shrink-0 w-full sm:w-auto">
            <a
              href="tel:25778646"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#f39223] hover:bg-[#e08112] text-white font-semibold text-sm px-6 py-3.5 rounded-full transition-all duration-200 cursor-pointer shadow-sm text-center"
            >
              <i className="fa-solid fa-phone" aria-hidden="true" />
              <span className="whitespace-nowrap">Ring 25 77 86 46</span>
            </a>
            <Link
              to="/kontakt"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-white font-semibold text-sm px-6 py-3.5 rounded-full border border-white/20 transition-all duration-200 cursor-pointer text-center"
            >
              <span>Send en besked</span>
              <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
            </Link>
          </div>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          {/* Col 1: Organisation & Brand */}
          <div className="space-y-4">
            <div className="inline-block bg-white p-3 rounded-xl shadow-xs">
              <img
                src={imageUrl('/_assets/unges-fremtid-logo.png', 'width=320,quality=90,format=auto')}
                alt="Unges Fremtid"
                className="h-12 w-auto object-contain"
                width={160}
                height={48}
              />
            </div>
            <p className="text-neutral-300 text-sm leading-relaxed">
              Unges Fremtid er en nonprofitorganisation, der arbejder for at hjælpe og styrke udsatte børn og unge til at få et meningsfyldt liv med stærke relationer i sunde fællesskaber, samt uddannelse og job.
            </p>
            <div className="pt-2">
              <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-[#f39223] bg-white/5 border border-[#f39223]/30 px-3 py-1 rounded-full">
                <i className="fa-solid fa-seedling" aria-hidden="true" />
                Livsmestring • Uddannelse • Job
              </span>
            </div>
          </div>

          {/* Col 2: Navigation */}
          <div>
            <h3 className="text-base font-bold text-white mb-4 tracking-wide">
              Hurtige links
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-neutral-300 hover:text-[#f39223] transition-colors inline-flex items-center gap-2">
                  <i className="fa-solid fa-angle-right text-xs text-[#f39223]" aria-hidden="true" />
                  <span>Forside</span>
                </Link>
              </li>
              <li>
                <Link to="/om-unges-fremtid" className="text-neutral-300 hover:text-[#f39223] transition-colors inline-flex items-center gap-2">
                  <i className="fa-solid fa-angle-right text-xs text-[#f39223]" aria-hidden="true" />
                  <span>Om Unges Fremtid</span>
                </Link>
              </li>
              <li>
                <Link to="/vores-arbejde" className="text-neutral-300 hover:text-[#f39223] transition-colors inline-flex items-center gap-2">
                  <i className="fa-solid fa-angle-right text-xs text-[#f39223]" aria-hidden="true" />
                  <span>Vores arbejde og indsatser</span>
                </Link>
              </li>
              <li>
                <Link to="/for-boern-og-unge" className="text-neutral-300 hover:text-[#f39223] transition-colors inline-flex items-center gap-2">
                  <i className="fa-solid fa-angle-right text-xs text-[#f39223]" aria-hidden="true" />
                  <span>For børn og unge</span>
                </Link>
              </li>
              <li>
                <Link to="/bliv-involveret" className="text-neutral-300 hover:text-[#f39223] transition-colors inline-flex items-center gap-2">
                  <i className="fa-solid fa-angle-right text-xs text-[#f39223]" aria-hidden="true" />
                  <span>Støt os / Involveret</span>
                </Link>
              </li>
              <li>
                <Link to="/nyheder" className="text-neutral-300 hover:text-[#f39223] transition-colors inline-flex items-center gap-2">
                  <i className="fa-solid fa-angle-right text-xs text-[#f39223]" aria-hidden="true" />
                  <span>Nyheder</span>
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-neutral-300 hover:text-[#f39223] transition-colors inline-flex items-center gap-2">
                  <i className="fa-solid fa-angle-right text-xs text-[#f39223]" aria-hidden="true" />
                  <span>Kontakt</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 3: Indsatser & Kerneområder */}
          <div>
            <h3 className="text-base font-bold text-white mb-4 tracking-wide">
              Vores kerneområder
            </h3>
            <ul className="space-y-3 text-sm text-neutral-300">
              <li className="flex items-start gap-2.5">
                <i className="fa-solid fa-check text-[#f39223] mt-1 shrink-0 text-xs" aria-hidden="true" />
                <span>Trivsel og livsmestring</span>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="fa-solid fa-check text-[#f39223] mt-1 shrink-0 text-xs" aria-hidden="true" />
                <span>Mentoring og stabile voksenrelationer</span>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="fa-solid fa-check text-[#f39223] mt-1 shrink-0 text-xs" aria-hidden="true" />
                <span>Skole, uddannelse og forebyggelse af frafald</span>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="fa-solid fa-check text-[#f39223] mt-1 shrink-0 text-xs" aria-hidden="true" />
                <span>Job, praktik og vejen til arbejdsmarkedet</span>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="fa-solid fa-check text-[#f39223] mt-1 shrink-0 text-xs" aria-hidden="true" />
                <span>Fællesskaber og forebyggelse af ensomhed</span>
              </li>
            </ul>
          </div>

          {/* Col 4: Kontakt & Organisation iht. kravene */}
          <div>
            <h3 className="text-base font-bold text-white mb-4 tracking-wide">
              Kontakt organisationen
            </h3>
            <div className="space-y-3 text-sm text-neutral-300">
              <div className="flex items-start gap-3">
                <i className="fa-solid fa-building text-[#f39223] mt-1 shrink-0" aria-hidden="true" />
                <div>
                  <p className="font-semibold text-white">Unges Fremtid</p>
                  <p className="text-neutral-400">Att.: Tom Pedersen</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot text-[#f39223] mt-1 shrink-0" aria-hidden="true" />
                <span>Koglevej 36, 8960 Randers SØ</span>
              </div>

              <div className="flex items-center gap-3">
                <i className="fa-solid fa-phone text-[#f39223] shrink-0" aria-hidden="true" />
                <a
                  href="tel:25778646"
                  className="hover:text-[#f39223] transition-colors font-semibold text-white whitespace-nowrap"
                >
                  25 77 86 46
                </a>
              </div>

              <div className="flex items-start gap-3">
                <i className="fa-solid fa-envelope text-[#f39223] mt-1 shrink-0" aria-hidden="true" />
                <a
                  href="mailto:ungesfremtid@outlook.dk"
                  className="hover:text-[#f39223] transition-colors block text-white font-medium break-all"
                >
                  ungesfremtid@outlook.dk
                </a>
              </div>

              <div className="flex items-center gap-3">
                <i className="fa-solid fa-id-card text-[#f39223] shrink-0" aria-hidden="true" />
                <span>CVR-nr: 46681606</span>
              </div>

              <div className="flex items-start gap-3">
                <i className="fa-solid fa-building-columns text-[#f39223] mt-1 shrink-0" aria-hidden="true" />
                <div className="space-y-0.5">
                  <p className="text-white font-medium">Reg. nr. 6124</p>
                  <p className="text-neutral-300">Konto 0024431401</p>
                </div>
              </div>
            </div>

            <div className="mt-6 pt-4 border-t border-white/10">
              <p className="text-xs text-neutral-400">
                Nonprofitorganisation for udsatte børn og unge i Danmark.
              </p>
            </div>
          </div>
        </div>

        {/* Bottom copyright bar */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-neutral-400">
          <p>© {currentYear} Unges Fremtid. Alle rettigheder forbeholdes.</p>
          <p className="text-neutral-400">
            Koglevej 36, 8960 Randers SØ • CVR: 46681606 • Tlf: <span className="whitespace-nowrap font-medium text-neutral-300">25 77 86 46</span>
          </p>
        </div>
      </div>
    </footer>
  )
}
